import { createAction } from '@reduxjs/toolkit'
import { StateKeysArrayType } from 'app/store/types'

export const resetStore = createAction<StateKeysArrayType | undefined>(
  'resetStore'
)
